import HeaderKids from "./HeaderKids.jsx";

export default HeaderKids;